module.exports = __webpack_public_path__ + "media/images/icons/speaker-70f9b800520f6058b6f5b9d898387662.png";